import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import svgPlay from '@img/icons/play-circle-instagram.svg';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  margin: var(--sectionSpacing) auto;
`;
const MediaInner = styled.figure `
  display: grid;
  justify-content: center;
  margin: 0 auto;
  max-width: 840px;

  &:hover {
    cursor: pointer;
  }
`;
const VideoWrapper = styled.div `
  position: relative;

  &::after {
    ${transition('opacity')};

    content: url('${svgPlay}');
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    filter: invert(1);
    height: ${fluid(75, 105)};
    opacity: 0.7;
    transform: translate(-50%, -50%);
    width: ${fluid(75, 105)};
  }

  ${MediaInner}:hover & {
    &::after {
      opacity: 1;
    }
  }
`;
const Image = styled.img ``;
const Caption = styled.figcaption `
  color: ${rgba(brand.black, 0.5)};
  ${fonts.brandonGrotesque.regular};
  font-size: 18px;
  line-height: 28px;
  margin: ${fluid(16, 8)} 0 0;
`;
const MediaEmbedStyles = {
    Container,
    MediaInner,
    Image,
    Caption,
    VideoWrapper,
};
export default MediaEmbedStyles;
